import * as types from "../types/contact-lists";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  retrieveContactLists,
  createNewSingleContactList,
  deleteSingleContactList,
  deleteMultipleContactListsArray,
  updateSingleContactList,
} from "../../networking/contact-lists/networking";

function* fetchContactListsDetails(action) {
  try {
    if (action.payload) {
      const contactLists = yield call(retrieveContactLists, action.payload);
      if (contactLists.error === null) {
        yield put({
          type: types.SET_CONTACT_LISTS_CONTENT,
          content: contactLists.payload,
        });
      } else {
        throw new Error("Kunne ikke hente filer");
      }
    } else {
      throw new Error("Kunne ikke hente filer");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_CONTACT_LISTS_CONTENT, message: e });
  }
}

function* performAddSingleContactList(action) {
  try {
    if (action.details) {
      var response = yield call(createNewSingleContactList, action.details);
      if (response.error === null && response.payload !== null) {
        yield put({
          type: types.GRANT_ADD_SINGLE_CONTACT_LIST,
          id: response.payload,
        });
        yield put({
          type: types.CHANGE_CONTACT_LISTS_MODALS,
          modal: { addModal: false },
        });
      } else {
        throw new Error("Kunne ikke legge til ny kunde.");
      }
    } else {
      throw new Error("Kunne ikke legge til ny kunde.");
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_ADD_SINGLE_CONTACT_LIST, message: error });
    yield put({
      type: types.CHANGE_CONTACT_LISTS_MODALS,
      modal: { addModal: false },
    });
  }
}

function* performRemoveSingleContactList(action) {
  try {
    if (action.details) {
      var response = yield call(deleteSingleContactList, action.details);
      if (response.error === null) {
        yield put({
          type: types.GRANT_DELETE_SINGLE_CONTACT_LIST,
          update: response.payload,
        });
        yield put({
          type: types.CHANGE_CONTACT_LISTS_MODALS,
          modal: { deleteModal: false },
        });
      } else {
        throw new Error("Kunne ikke fjerne kunde.");
      }
    } else {
      throw new Error("Kunne ikke slette kunde.");
    }
  } catch ({ error }) {
    yield put({
      type: types.REVOKE_DELETE_SINGLE_CONTACT_LIST,
      message: error,
    });
    yield put({
      type: types.CHANGE_CONTACT_LISTS_MODALS,
      modal: { deleteModal: false },
    });
  }
}

function* performRemoveContactListArray(action) {
  try {
    if (action.details) {
      const response = yield call(
        deleteMultipleContactListsArray,
        action.details
      );
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_CONTACT_LIST_ARRAY });
      } else {
        throw new Error("Kunne ikke slette kunder.");
      }
    } else {
      throw new Error("Kunne ikke slette kunder.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_CONTACT_LIST_ARRAY, message: e });
  }
}

function* performUpdateSingleContactList(action) {
  try {
    if (action.details) {
      var response = yield call(updateSingleContactList, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_SINGLE_CONTACT_LIST });
        yield put({
          type: types.CHANGE_CONTACT_LISTS_MODALS,
          modal: { editModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere kunde.");
      }
    }
  } catch ({ error }) {
    yield put({
      type: types.REVOKE_UPDATE_SINGLE_CONTACT_LIST,
      message: error,
    });
    yield put({
      type: types.CHANGE_CONTACT_LISTS_MODALS,
      modal: { editModal: false },
    });
  }
}

function* contactListsSaga() {
  yield all([
    takeEvery(types.REQUEST_CONTACT_LISTS_CONTENT, fetchContactListsDetails),
    takeEvery(
      types.REQUEST_ADD_SINGLE_CONTACT_LIST,
      performAddSingleContactList
    ),
    takeEvery(
      types.REQUEST_DELETE_SINGLE_CONTACT_LIST,
      performRemoveSingleContactList
    ),
    takeEvery(
      types.REQUEST_DELETE_CONTACT_LIST_ARRAY,
      performRemoveContactListArray
    ),
    takeEvery(
      types.REQUEST_UPDATE_SINGLE_CONTACT_LIST,
      performUpdateSingleContactList
    ),
  ]);
}

export default contactListsSaga;
